export default {"src":"/_next/static/media/NewMexico.c748a5a3.svg","height":750,"width":800,"blurWidth":0,"blurHeight":0};